<mat-card
    appearance="outlined"
    class="provider-card"
    fxLayout="column"
    fxLayoutAlign="space-between"
    *transloco="let t"
    [ngClass]="{ added: provider.selected }"
    [title]="provider.name"
>
    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <a
            *ngIf="provider.webSite; else header"
            [href]="provider.webSite"
            target="_blank"
            rel="noopener"
            style="text-decoration: unset"
        >
            <ng-container *ngTemplateOutlet="header"></ng-container>
        </a>
        <ng-template #header>
            <mat-card-header class="provider-card-header">
                <img
                    class="provider-card-image"
                    mat-card-avatar
                    src="{{
                        provider.logoPath
                            ? provider.logoPath
                            : 'https://placeholder.pics/svg/300/DEDEDE/FFFFFF-FFFFFF'
                    }}"
                    [alt]="provider.name"
                />
                <mat-card-title
                    class="{{ provider.webSite ? 'title-link' : '' }}"
                >
                    {{ provider.name }}
                    <mat-icon *ngIf="provider.webSite">open_in_new</mat-icon>
                </mat-card-title>
            </mat-card-header>
        </ng-template>
        <mat-card-content class="provider-card-content">
            <p class="description" [innerHTML]="provider.description"></p>
            <span
                *ngIf="
                    (provider?.countiesServed ?? []).length === 0 &&
                    (provider?.sites ?? []).length === 0
                "
            >
                <mat-list
                    class="provider-programs-list"
                    *ngIf="!provider.isWaitlist"
                    dense
                >
                    <mat-list-item
                        class="provider-programs-list-item"
                        *ngFor="let program of provider.programs"
                    >
                        <mat-icon class="list-item-check-icon" matListIcon
                            >check</mat-icon
                        >
                        <span>{{ program.name }}</span>
                    </mat-list-item>
                </mat-list>
            </span>
            <mat-expansion-panel
                class="provider-expansion-panel"
                *ngIf="
                    (provider?.countiesServed ?? []).length > 0 ||
                    (provider?.sites ?? []).length > 0
                "
            >
                <mat-expansion-panel-header
                    class="provider-expansion-panel-header"
                >
                    <mat-panel-title>
                        <span>{{ t("provider.programs-offered") }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list dense>
                    <mat-list-item *ngFor="let program of provider.programs">
                        <mat-icon class="list-item-check-icon" matListIcon
                            >check</mat-icon
                        >
                        <span>{{ program.name }}</span>
                    </mat-list-item>
                </mat-list>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="provider-expansion-panel"
                *ngIf="(provider?.countiesServed ?? []).length > 0"
            >
                <mat-expansion-panel-header
                    class="provider-expansion-panel-header"
                >
                    <mat-panel-title>
                        <span>{{ t("provider.counties-served") }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list dense>
                    <mat-list-item
                        *ngFor="let county of provider.countiesServed"
                    >
                        <mat-icon class="list-item-check-icon" matListIcon
                            >check</mat-icon
                        >
                        <span>{{ county }}</span>
                    </mat-list-item>
                </mat-list>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="provider-expansion-panel"
                *ngIf="(provider?.sites ?? []).length > 0 && !provider.selected"
            >
                <mat-expansion-panel-header
                    class="provider-expansion-panel-header"
                >
                    <mat-panel-title>
                        <span>{{ t("provider.locations") }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list class="provider-expansion-panel-list" dense>
                    <mat-list-item
                        class="provider-expansion-panel-list-item"
                        *ngFor="let site of provider.sites"
                    >
                        <div
                            fxFlex="100%"
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            wrap
                        >
                            <mat-icon matListIcon class="list-item-check-icon"
                                >check</mat-icon
                            >
                            <a
                                href="https://maps.google.com/?q={{
                                    singleLineAddress(site)
                                }}"
                                target="_blank"
                                rel="noopener"
                                *ngIf="provider.address"
                                matTooltip="{{ singleLineAddress(site) }}"
                                class="location-link"
                            >
                                {{ site.streetAddress }}<br />
                                {{ site.city }}, {{ site.stateCode }}
                                {{ site.postalCode }}
                            </a>
                        </div>
                    </mat-list-item>
                </mat-list>
            </mat-expansion-panel>
        </mat-card-content>
    </div>
    <div
        fxLayout="row wrap"
        fxLayoutAlign="space-around"
        class="footer-container"
    >
        <div *ngIf="(provider?.sites ?? []).length > 0">
            <mat-expansion-panel [expanded]="provider.selected">
                <mat-list dense>
                    <mat-panel-title class="mat-expansion-title">
                        <span>{{ t("provider.preferred-locations") }}</span>
                    </mat-panel-title>
                    <mat-list-item *ngFor="let site of provider.sites">
                        <div fxLayout="row" fxLayoutAlign="space-between">
                            <mat-checkbox
                                color="primary"
                                [value]="site.siteId.toString()"
                                (change)="selectSite($event)"
                                [name]="site.streetAddress"
                            >
                                <span
                                    >{{ site.streetAddress }}<br />
                                    {{ site.city }}, {{ site.stateCode }}
                                    {{ site.postalCode }}&nbsp;</span
                                >
                            </mat-checkbox>
                            <!-- <a
                            href="https://maps.google.com/?q={{ singleLineAddress(site) }}"
                            target="_blank"
                             rel="noopener"
                            *ngIf="provider.address"
                            matTooltip="{{ singleLineAddress(site) }}"
                        >
                            <span>Map&nbsp;</span><mat-icon>open_in_new</mat-icon>
                        </a> -->
                        </div>
                    </mat-list-item>
                </mat-list>
            </mat-expansion-panel>
        </div>
        <mat-divider></mat-divider>
        <mat-card-footer
            fxLayout="row"
            fxLayoutAlign="space-around center"
            class="provider-footer"
        >
            <div *ngIf="provider.isWaitlist" style="margin-left: auto"></div>
            <div *ngIf="!provider.isWaitlist">
                <a
                    href="https://maps.google.com/?q={{
                        singleLineAddress(provider.address)
                    }}"
                    target="_blank"
                    rel="noopener"
                    *ngIf="provider.address"
                    matTooltip="{{ singleLineAddress(provider.address) }}"
                >
                    {{ singleLineAddress(provider.address) }}
                    <mat-icon>open_in_new</mat-icon>
                </a>
            </div>
            <button
                mat-button
                [ngClass]="
                    provider.selected ? 'mat-flat-button' : 'mat-stroked-button'
                "
                color="primary"
                (click)="toggleSelected()"
                name="Select Provider"
                id="{{ 'provider-' + provider.providerId + '-button' }}"
            >
                <mat-icon *ngIf="provider.selected">check</mat-icon>
                {{
                    (provider.selected
                        ? t("provider.added")
                        : t("provider.select")
                    ) | uppercase
                }}
            </button>
        </mat-card-footer>
    </div>
</mat-card>
